import React, { useState } from 'react'
import './AppFormItem.less'
import api, { MetadataOption } from 'api'
import { Switch } from 'antd'

export interface AppSwitchProps {
	checked?: boolean
	onChange?: (checked: boolean) => void
	checkedLabel?: string
	unCheckedLabel?: string
	readonly?: boolean
}

export const AppSwitch = (props: AppSwitchProps) => {
	const [checked, setChecked] = useState(props.checked)

	const onChange = (newChecked: boolean) => {
		props.onChange && props.onChange(newChecked)
		setChecked(newChecked)
	}

	return (
		<div
			style={{
				// border: '1px solid',
				height: '30px',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<Switch
				checkedChildren={props.checkedLabel || ''}
				unCheckedChildren={props.unCheckedLabel || ''}
				checked={checked}
				onChange={onChange}
			/>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppSwitch.tsx